import {ComponentRegistryFactory} from "./src/component-registry-factory";
import AdviceBundleView from "./src/components/advice-bundle.vue";
import AdviceView from "./src/components/advice.vue";
import AdviceNavigationView from "./src/components/advice-navigation.vue";
import AdvisorView from "./src/components/advisor.vue";
import AdvisorSectionView from "./src/components/advisor-section.vue";
import AlternativeProductsView from "./src/components/alternative-products.vue";
import BrandingView from "./src/components/branding.vue";
import CheckboxAnswerView from "./src/components/checkbox-answer.vue";
import ChoiceAnswerView from "./src/components/choice-answer.vue";
import ChoiceQuestionView from "./src/components/choice-question.vue";
import ComparisonView from "./src/components/comparison.vue";
import ComparisonTableView from "./src/components/comparison-table.vue";
import DropDownQuestionView from "./src/components/drop-down-question.vue";
import InfoTextView from "./src/components/info-text.vue";
import FilterCheckboxAnswerView from "./src/components/filter-checkbox-answer.vue";
import FilterChoiceAnswerView from "./src/components/filter-choice-answer.vue";
import FilterDropDownQuestionView from "./src/components/filter-dropdown-question.vue";
import FilterPanelView from "./src/components/filter-panel.vue";
import FilterQuestionView from "./src/components/filter-question.vue";
import FilterRadioButtonAnswerView from "./src/components/filter-radio-button-answer.vue";
import LongTextQuestionView from "./src/components/long-text-question.vue";
import ModalView from "./src/components/modal.vue";
import PageView from "./src/components/page.vue";
import PageSelectorView from "./src/components/page-selector.vue";
import PagesNavigationView from "./src/components/pages-navigation.vue";
import PdfDownloadButtonView from "./src/components/pdf-download-button.vue";
import PdfContentView from "./src/components/pdf-content.vue";
import ProductClickoutLinkView from "./src/components/product-clickout-link.vue";
import ProductAddToCartView from "./src/components/product-add-to-cart.vue";
import ProductComparisonSelectorView from "./src/components/product-comparison-selector.vue";
import ProductPriceView from "./src/components/product-price.vue";
import ProductPriceComplementaryTextView
    from "./src/components/product-price-complementary-text.vue";
import ProductRatingView from "./src/components/product-rating.vue";
import ProductRecommendationView from "./src/components/product-recommendation.vue";
import PropertyGroupView from "./src/components/property-group.vue";
import PropertyHeaderView from "./src/components/property-header.vue";
import QuestionHeadView from "./src/components/question-head.vue";
import QuestionValidationMessageView from "./src/components/question-validation-message.vue";
import QuestionnaireView from "./src/components/questionnaire-section.vue";
import RadioButtonAnswerView from "./src/components/radio-button-answer.vue";
import RangeQuestionView from "./src/components/range-question.vue";
import ResultsSectionView from "./src/components/results-section.vue";
import ShownProductsView from "./src/components/shown-products.vue";
import SliderView from "./src/components/slider.vue";
import SliderQuestionView from "./src/components/slider-question.vue";
import SortView from "./src/components/sort.vue";
import StartOverButtonView from "./src/components/start-over-button.vue";
import TextQuestionView from "./src/components/text-question.vue";
import TopProductView from "./src/components/top-product.vue";
import FileUploadQuestionView from "./src/components/file-upload-question.vue";
import {StyleRegistryFactory} from "./src/style-registry-factory";
import {mapFontType} from "./src/fonts/font-types";
import FilePDF from "./src/utils/file-pdf";

export {
    AdviceBundleView,
    AdviceView,
    AdviceNavigationView,
    AdvisorView,
    AdvisorSectionView,
    AlternativeProductsView,
    BrandingView,
    CheckboxAnswerView,
    ChoiceAnswerView,
    ChoiceQuestionView,
    ComparisonView,
    ComparisonTableView,
    DropDownQuestionView,
    FilePDF,
    FilterDropDownQuestionView,
    FilterCheckboxAnswerView,
    FilterChoiceAnswerView,
    FilterPanelView,
    FilterQuestionView,
    FilterRadioButtonAnswerView,
    InfoTextView,
    LongTextQuestionView,
    ModalView,
    PageView,
    PageSelectorView,
    PagesNavigationView,
    PdfDownloadButtonView,
    PdfContentView,
    ProductClickoutLinkView,
    ProductAddToCartView,
    ProductComparisonSelectorView,
    ProductPriceView,
    ProductPriceComplementaryTextView,
    ProductRatingView,
    ProductRecommendationView,
    PropertyGroupView,
    PropertyHeaderView,
    QuestionHeadView,
    QuestionValidationMessageView,
    QuestionnaireView,
    RadioButtonAnswerView,
    RangeQuestionView,
    ResultsSectionView,
    ShownProductsView,
    SliderView,
    SliderQuestionView,
    SortView,
    StartOverButtonView,
    TextQuestionView,
    TopProductView,
    FileUploadQuestionView,
    mapFontType,
};

export {ComponentRegistryFactory, StyleRegistryFactory};

export * from "./src/configuration";
export * from "./src/plugins";
export * from "./src/styles";
export * from "./src/components/utils";
